import helper, { bindUrl } from "../helper";

export const pageQueryWarehouse = function(params) {
  return helper.get("/warehouse/pageQueryWarehouse", params);
};
export const queryWarehouse = function(params) {
  return helper.get("/warehouse/queryWarehouse", params);
};

export const addWarehouse = function(params) {
  return helper.post("/warehouse/addWarehouseMobile", params);
};
export const updateWarehouse = function(params) {
  return helper.post("/warehouse/updateWarehouse", params);
};

export const queryWarehouseByCompanyId = function(params) {
  return helper.get("/warehouse/queryWarehouseByCompanyId", params);
};

export const pageWarehouse = function(params) {
  return helper.get("/warehouse/pageWarehouse", params);
};
export const queryWarehouseVideos = function(params) {
  return helper.get("/warehouse/queryWarehouseVideos", params);
};

/**
 *
 * @param {Object} params
 * @param {string} params.warehouseId
 */
export const commitWarehouseFile = function(params) {
  return helper.post("/warehouse/commitFile", params);
};

export const pageQueryWarehouseItem = function(params) {
  return helper.get("/fishWarehouse/pageQueryWarehouseItem", params);
};

export const queryByFishItemId = function(params) {
  return helper.get("/fishWarehouse/queryByFishItemId", params);
};

export const warehouseHistory = function(params) {
  return helper.get("/warehouseHistory/pageQuery", params);
};

export const findWarehouseInfo = function(params) {
  return helper.get("/warehouseHistory/findWarehouseInfo", params);
};

export const showWarehouseInfo = function(params) {
  return helper.get("/warehouseHistory/showWarehouseInfo", params);
};

export const addHistoryRecord = function(params) {
  return helper.post("/warehouseHistory/addHistoryRecord", params);
};

/**
 * 通过业务id获取信息
 * GET /v1/warehouseBook/findOneByBusinessId
 * @param {Object} queryParams
 * @param {number} queryParams.businessId - businessId
 */
export function findOneByBusinessId(queryParams) {
  return helper.request({
    url: bindUrl("/v1/warehouseBook/findOneByBusinessId", {}),
    method: "GET",
    params: queryParams
  });
}
